import React from 'react';

import type { ExtendedNavigationPath } from '~hooks/useNavigationLinks/types';
import { Link } from '~i18n/navigation';
import type { DropdownProps } from '~shared/ui/atoms/Dropdown';
import { Dropdown, DropdownElement } from '~shared/ui/atoms/Dropdown';
import type { Ref } from '~types/Ref';

export const MenuDropdown = ({
	items,
	...props
}: DropdownProps &
	Ref<HTMLElement> & { items: ExtendedNavigationPath[]; children?: never }) => {
	return (
		<Dropdown {...props}>
			{items.map((child) => (
				<DropdownElement
					data-name={child['data-name']}
					as={Link}
					href={child.path}
					onClick={child.handle}
					scroll={false}
					icon={child.icon}
					key={child.path}
				>
					{child.text}
				</DropdownElement>
			))}
		</Dropdown>
	);
};
